import React, { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, DatePicker, Form, Select, Spin, Table } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import 'jspdf-autotable';
import { CSVLink } from "react-csv";
import csv from "../../assets/images/csv.png";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getshippedDetailByPaymentMethod } from "../../redux/actions/shippedDetailByPaymentMethod.action.js";
import filterHelper, { sorterHelper } from "../../utils/filterHelper.js";

const ShippedDetailByPaymentMethod = ({ token }) => {
  TabTitle("Shipped Detail By Payment Type")
  const userName = ReadCookie("name");
  const menuId = ReadCookie("menuId");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const { shippedbyPaymentMethod } = useSelector((state) => state);
  const [excelData, setExcelData] = useState([])




  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      dispatch(getshippedDetailByPaymentMethod(token, values)).then((res) => {
        setLoading(false);
      });
    }).catch((error) => {
      setLoading(false);
    })
  }

  const handlePrint = () => {
    const css = '@page { margin-top: 25px; margin-bottom: 25px; margin-right: 0px; padding: 0px}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',

      render: (text, record, index) => {
        return index + 1;
      },
      width: 40,
    },
    {
      title: "Term",
      dataIndex: "term_name",
      key: "term_name",
      ...sorterHelper('term_name')
    },
    {
      title: "Payment Type",
      dataIndex: "payment_method",
      key: "payment_method",
      ...sorterHelper('payment_method')
    },
    {
      title: "Kids",
      dataIndex: "kids",
      key: "kids",
      render: (text, record) => {
        return <>${numeral(record.kids).format("0,00.00")}
        </>
      },
      align: "right",
      ...sorterHelper('kids', 'num')
    },
    {
      title: "Men ",
      dataIndex: "men",
      key: "men",
      render: (text, record) => {
        return <>${numeral(record.men).format("0,00.00")}
        </>
      },
      align: "right",
      ...sorterHelper('men', 'num')
    },
    {
      title: "Unisex",
      dataIndex: "unisex",
      key: "unisex",
      render: (text, record) => {
        return <>${numeral(record.unisex).format("0,00.00")}
        </>
      },
      align: "right",
      ...sorterHelper('unisex', 'num')
    },
    {
      title: "Women",
      dataIndex: "women",
      key: "women",
      render: (text, record) => {
        return <>${numeral(record.women).format("0,00.00")}
        </>
      },
      align: "right",
      ...sorterHelper('women', 'num')
    },
    {
      title: "Grand Total",
      dataIndex: "grand_total",
      key: "grand_total",
      render: (text, record) => {
        return <>${numeral(record.grand_total).format("0,00.00")}
        </>
      },
      align: "right",
      ...sorterHelper('grand_total', 'num')
    },
    {
      title: "% To Total",
      key: "percent_total",
      align: "right",
      render: (text, record) => {
        const data = shippedbyPaymentMethod?.payload?.data || [];

        const totalGrandTotal = data.reduce(
          (sum, row) => sum + Number(row.grand_total || 0),
          0
        );

        const percent =
          totalGrandTotal > 0
            ? (Number(record.grand_total || 0) / totalGrandTotal) * 100
            : 0;

        return <>{numeral(percent).format("0,0.00")} %</>;
      },
    }
  ];

  const downloadExcelFileData = (data) => {
    if (!data || !data.length) return;

    // 1️⃣ Grand Totals
    const totalKids = data.reduce((sum, row) => sum + Number(row.kids || 0), 0);
    const totalMen = data.reduce((sum, row) => sum + Number(row.men || 0), 0);
    const totalUnisex = data.reduce((sum, row) => sum + Number(row.unisex || 0), 0);
    const totalWomen = data.reduce((sum, row) => sum + Number(row.women || 0), 0);
    const totalGrand = data.reduce((sum, row) => sum + Number(row.grand_total || 0), 0);

    // 2️⃣ Payment method groups
    const paymentGroups = {};
    data.forEach((row) => {
      const method = row.payment_method || "Unknown";
      if (!paymentGroups[method]) paymentGroups[method] = { kids: 0, men: 0, unisex: 0, women: 0, grand: 0 };
      paymentGroups[method].kids += Number(row.kids || 0);
      paymentGroups[method].men += Number(row.men || 0);
      paymentGroups[method].unisex += Number(row.unisex || 0);
      paymentGroups[method].women += Number(row.women || 0);
      paymentGroups[method].grand += Number(row.grand_total || 0);
    });

    // 3️⃣ Prepare sheet data
    const sheetData = [];

    // Header
    sheetData.push([
      "#",
      "Term",
      "Payment Type",
      "Kids",
      "Men",
      "Unisex",
      "Women",
      "Grand Total",
      "% To Total",
    ]);

    // Rows
    data.forEach((row, index) => {
      const percentTotal = totalGrand ? (Number(row.grand_total || 0) / totalGrand) * 100 : 0;
      sheetData.push([
        index + 1,
        row.term_name || "",
        row.payment_method || "",
        Number(row.kids || 0).toFixed(2),
        Number(row.men || 0).toFixed(2),
        Number(row.unisex || 0).toFixed(2),
        Number(row.women || 0).toFixed(2),
        Number(row.grand_total || 0).toFixed(2),
        percentTotal.toFixed(2) + "%",
      ]);
    });

    // Grand Total row
    sheetData.push([
      "",
      "",
      "Grand Total :",
      totalKids.toFixed(2),
      totalMen.toFixed(2),
      totalUnisex.toFixed(2),
      totalWomen.toFixed(2),
      totalGrand.toFixed(2),
      "100%",
    ]);

    // Payment method % rows
    Object.entries(paymentGroups).forEach(([method, totals]) => {
      sheetData.push([
        "",
        "",
        `${method} % to TTL :`,
        totalKids ? ((totals.kids / totalKids) * 100).toFixed(2) + "%" : "0.00%",
        totalMen ? ((totals.men / totalMen) * 100).toFixed(2) + "%" : "0.00%",
        totalUnisex ? ((totals.unisex / totalUnisex) * 100).toFixed(2) + "%" : "0.00%",
        totalWomen ? ((totals.women / totalWomen) * 100).toFixed(2) + "%" : "0.00%",
        totalGrand ? ((totals.grand / totalGrand) * 100).toFixed(2) + "%" : "0.00%",
        "",
      ]);
    });

    // 4️⃣ Create workbook & sheet
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Shipped-Detail-By-Payment-Type");

    // 5️⃣ Export Excel file
    XLSX.writeFile(wb, `ShippedDetailByPaymentType_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
  };


  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between business_class_oms distributor distributor2">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>
                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class" >
                        <input
                          type="image"
                          name="ImgCSV"
                          alt="Export to CSV"
                          id="ImgCSV"
                          title="Export to CSV"
                          src={csv}
                          onClick={() => downloadExcelFileData(shippedbyPaymentMethod?.payload?.data || [])}
                          style={{ borderWidth: "0px", height: "24px", float: "inline-end", margin: "12px" }}
                        />
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Shipped Detail By Payment Type
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    layout="horizontal"
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <hr className="my-1" />
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">From Date:</label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="from_date"
                              initialValue={moment().startOf('year')}
                            >
                              <DatePicker
                                size='small'
                                className="styleInput w-100"
                                format={"MM-DD-YYYY"}
                                defaultValue={moment().format("MM-DD-YYYY")}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label className="labels width30">To Date:</label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="to_date"
                              initialValue={moment().endOf('year')}
                            >
                              <DatePicker
                                size='small'
                                className="styleInput w-100"
                                format={"MM-DD-YYYY"}
                                defaultValue={moment().format("MM-DD-YYYY")}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-1">
                        <div style={{ marginTop: "3px", display: "flex", justifyContent: "right" }} >
                          <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content ar_aging_summary_table_content"
        style={{ width: '1300px' }}
        ref={tableRef} >
        <div>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : shippedbyPaymentMethod?.payload?.data.length ? (
            <Table
              size="small"
              bordered={false}
              type="company"
              style={{ fontSize: '10.3px' }}
              className="border-line-th bottom-align-th table-td-border-right th-general-style td-general-style border omsTable"
              dataSource={shippedbyPaymentMethod?.payload?.data || []}
              columns={columns}
              loading={shippedbyPaymentMethod.loading}
              pagination={false}
              summary={() => {
                const data = shippedbyPaymentMethod?.payload?.data || [];

                // 1️⃣ Grand total for all data
                const totalKids = data.reduce((sum, row) => sum + Number(row.kids || 0), 0);
                const totalMen = data.reduce((sum, row) => sum + Number(row.men || 0), 0);
                const totalUnisex = data.reduce((sum, row) => sum + Number(row.unisex || 0), 0);
                const totalWomen = data.reduce((sum, row) => sum + Number(row.women || 0), 0);
                const totalGrand = data.reduce((sum, row) => sum + Number(row.grand_total || 0), 0);

                // 2️⃣ Totals per payment method
                const paymentGroups = {};
                data.forEach((row) => {
                  const method = row.payment_method || "Unknown";
                  if (!paymentGroups[method]) {
                    paymentGroups[method] = { kids: 0, men: 0, unisex: 0, women: 0, grand: 0 };
                  }
                  paymentGroups[method].kids += Number(row.kids || 0);
                  paymentGroups[method].men += Number(row.men || 0);
                  paymentGroups[method].unisex += Number(row.unisex || 0);
                  paymentGroups[method].women += Number(row.women || 0);
                  paymentGroups[method].grand += Number(row.grand_total || 0);
                });

                return (
                  <>
                    {/* Grand Total row */}
                    <Table.Summary.Row>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p style={{ textAlign: "right" }}>Grand Total :</p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p style={{ textAlign: "right" }} className="totalquantity">
                          ${numeral(totalKids).format("0,00.00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p style={{ textAlign: "right" }} className="totalquantity">
                          ${numeral(totalMen).format("0,00.00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p style={{ textAlign: "right" }} className="totalquantity">
                          ${numeral(totalUnisex).format("0,00.00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p style={{ textAlign: "right" }} className="totalquantity">
                          ${numeral(totalWomen).format("0,00.00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell>
                        <p style={{ textAlign: "right" }} className="totalquantity">
                          ${numeral(totalGrand).format("0,00.00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                    </Table.Summary.Row>

                    {/* Payment Method totals */}
                    {Object.entries(paymentGroups).map(([method, totals]) => (
                      <Table.Summary.Row key={method}>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }}>{method} % to TTL :</p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            {numeral((totals.kids / totalKids) * 100).format("0,00.00")}%
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            {numeral((totals.men / totalMen) * 100).format("0,00.00")}%
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            {numeral((totals.unisex / totalUnisex) * 100).format("0,00.00")}%
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            {numeral((totals.women / totalWomen) * 100).format("0,00.00")}%
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell>
                          <p style={{ textAlign: "right" }} className="totalquantity">
                            {numeral((totals.grand / totalGrand) * 100).format("0,00.00")}%
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                      </Table.Summary.Row>
                    ))}
                  </>
                );
              }}
            />
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ShippedDetailByPaymentMethod;

